let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3fuR9")).then(() => parcelRequire('l8CqS'));